module.exports = __webpack_public_path__ + "img/game_night_graphic.227ccbb3.png";